export { default } from './sliceZone';
